import { Injectable } from '@angular/core';
import { GenericResponse } from '../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({ providedIn: 'root' })
export class ActionTypeDataService {
    constructor(
        private dataProvider: DataService
    ) { }

    GetList(): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<any>(Urls.GetActionTypeList).toPromise();
    }
    Update(model: any): Promise<any> {
        return this.dataProvider.Post<any>(Urls.UpdateActionType, model).toPromise();
    }
}